import { NgModule } from "@angular/core";
import { SelectCourierPartnerComponent } from "./select-courier-partner/select-courier-partner.component";
import { TableViewComponent } from "./select-courier-partner/table-view/table-view.component";
import { CardViewComponent } from "./select-courier-partner/card-view/card-view.component";
import { MatRadioModule } from "@angular/material/radio";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { PipesModule } from "../../pipes/pipes.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSortModule } from "@angular/material/sort";
import { DataLoaderModule } from "../dynamic-table/table-components/data-loader/data-loader.module";
import { ErrorMessageModule } from "../error-message/error-message.module";
import { MatSelectModule } from "@angular/material/select";
import { MatDialogModule } from "@angular/material/dialog";
import { ChargeWeightDetailsComponent } from "./select-courier-partner/modal/charge-weight-details/charge-weight-details.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { PriceBreakupDetailsComponent } from "./select-courier-partner/modal/price-breakup-details/price-breakup-details.component";

@NgModule({
  declarations: [
    SelectCourierPartnerComponent,
    TableViewComponent,
    CardViewComponent,
    ChargeWeightDetailsComponent,
    PriceBreakupDetailsComponent
  ],
  imports: [
    // shared
    FuseSharedModule,
    DataLoaderModule,
    ErrorMessageModule,
    PipesModule,

    // material
    MatTableModule,
    MatIconModule,
    MatRadioModule,
    MatTooltipModule,
    MatSelectModule,
    MatSortModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule
  ],
  exports: [SelectCourierPartnerComponent]
})
export class SelectCourierPartnerModule {}
